import { ISection } from '@sdk/contracts';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { AddSectionDescription } from '../AddSectionDescription';

import { Wrapper } from './SectionDescription.styles';

type Props = {
  section: ISection;
  isSectionSelected: boolean;
};

export const SectionDescription: React.FC<Props> = ({ section, isSectionSelected }) => {
  const { description } = section;
  const { colors } = useTheme();
  const { t } = useTranslation('CourseTranslations');

  const isDescriptionEmpty = !description || description.trim().length === 0;

  return (
    <Wrapper
      onClick={e => e.stopPropagation()}
      color={colors.green6}
      ellipsis={
        !isSectionSelected && {
          rows: 2,
          expandable: 'collapsible',
          symbol: isExpanded => (isExpanded ? t('VIEW_LESS') : t('VIEW_MORE'))
        }
      }>
      {isDescriptionEmpty ? <AddSectionDescription section={section} /> : description}
    </Wrapper>
  );
};
